import * as Fathom from 'fathom-client'

const SITE_ID = String(process.env.REACT_APP_FATHOM_SITE_ID || '').trim()
const FIREBASE_PROJECT_ID = String(
    process.env.REACT_APP_FIREBASE_PROJECT_ID || ''
).trim()

// Production hosts only. Staging, Replit previews, and localhost must not
// write into the live Fathom site. The Fathom dashboard firewall must also
// allow these hosts — the previous allowed origin was the Replit preview
// domain (*.riker.replit.dev), which will drop app.quillnote.co traffic.
const PRODUCTION_HOSTS = new Set([
  'app.quillnote.co',
  FIREBASE_PROJECT_ID ? `${FIREBASE_PROJECT_ID}.web.app` : '',
  FIREBASE_PROJECT_ID ? `${FIREBASE_PROJECT_ID}.firebaseapp.com` : ''
].filter(Boolean))

export const fathomEnabled = SITE_ID.length > 0

let initialized = false

function currentHostname() {
  if (typeof window === 'undefined' || !window.location) return ''
  return window.location.hostname
}

function isProductionHost() {
  return PRODUCTION_HOSTS.has(currentHostname())
}

/**
 * Loads Fathom once for the SPA. Safe to call from React effects.
 * No-ops when the site ID is missing or the host is not production.
 */
export function initFathom() {
  if (initialized) return
  initialized = true

  if (!fathomEnabled) {
    if (process.env.NODE_ENV === 'production' && isProductionHost()) {
      console.warn(
        '[fathom] REACT_APP_FATHOM_SITE_ID is empty. ' +
        'Production analytics are disabled. Set the public Site ID in ' +
        '.env.production (Fathom → Settings → Sites) and rebuild hosting.'
      )
    }
    return
  }

  if (!isProductionHost()) return

  Fathom.load(SITE_ID, {
    spa: 'auto'
  })
}

/**
 * Records a named Fathom event. No-ops when analytics are disabled.
 * @param {string} eventName
 */
export function trackFathomEvent(eventName) {
  if (!fathomEnabled || !isProductionHost() || !eventName) return
  Fathom.trackEvent(String(eventName))
}
